export default "__VITE_ASSET__C0ZK1zLB__"